import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var MainLayout = function MainLayout(props) {
  var children = props.children;
  return _jsx("div", {
    className: "flex flex-col h-screen",
    children: _jsx("main", {
      children: children
    })
  });
};